import userAuthorizedAxios from './userAuthorizedAxios';

export default {
  getAuthorizedLinkToShopifyStore: (link: string): Promise<string> => userAuthorizedAxios.get<{ link: string }>(`/api/customer/store/shopify/auth-link?url=${link}`)
    .then((res) => res.data.link),
};
